<template>
  <div class="mobile-menu-top fixed w-full overflow-y-auto scrolling-touch h-full hidden text-NotoSansLight tracking-widest font-light" v-if="products !== null" ref="menu">

    <div class="cursor-pointer text-sm text-white text-NotoSansLight">
      <router-link :to="{ name: 'login' }"  v-if="!authorized"
        class="px-6 mobile-menu-title leading-snug block tracking-wider py-4 pb-5">
        <font-awesome-icon :icon="['far', 'user']" class="text-white text-2xl mr-3" />Sign in
      </router-link>
      <router-link :to="{ name: 'manage' }" v-if="authorized" @click.native="$emit('closeMobileMenu', false)"
        class="px-6 mobile-menu-title leading-snug block tracking-wider py-4 pb-5">
        <font-awesome-icon :icon="['far', 'user']" class="text-white text-2xl mr-3" />Hello, {{ user?.name ?? 'user' }}
      </router-link>
    </div>

    <ul claas="block w-full text-left cursor-pointer">
      <!-- 最新優惠 -->
      <li class="relative cursor-pointer text-base">

        <div class="text-sm px-6 py-3 mobile-menu-title leading-snug block arrow relative text-white cursor-pointer"
          ref="title" @click.prevent="toggleEvent()">
          最新優惠</div>

        <ul class="product-menu__cat hidden bg-white" ref="saleList">
          <li class="border-b border-gray-300">
            <router-link @click.native="closeMenu" :to="{ path: '/products/recent' }" class="text-sm px-8 py-3 tracking-wide cursor-pointer" style="background-color: #f3f3f3;">
              最新優惠首頁
            </router-link>
          </li>
          <li class="border-b border-gray-300" v-for="(item, index) in events" :key="index">
            <a @click="secondSaleMenu(item)"
              class="text-sm px-8 py-3 tracking-wide cursor-pointer" style="background-color: #f3f3f3;"
              >{{ item.name }}
            </a>
          </li>
        </ul>
      </li>

      <!-- 雜誌/叢書/套書 -->
      <li class="relative cursor-pointer" v-for="(item, index) in products" :key="index" :class="item === 'newbook'"
        >
        <div class="text-sm px-6 py-3 mobile-menu-title leading-snug block arrow relative text-white"
          ref="title" v-if="item.items" @click="toggleMenu(index)">
          {{ item.title }}</div>
          <ul class="product-menu__cat hidden bg-white" ref="childItems" :class="{ hidden: item.items }">
            <li class="border-b border-gray-300">
              <router-link @click.native="closeMenu" :to="{ path: returnIndexPath(index) }" class="text-sm px-8 py-3 tracking-wide cursor-pointer" style="background-color: #f3f3f3;">
                {{ item.title }}首頁
              </router-link>
            </li>
            <li class="border-b border-gray-300" v-for="(child, idx) in item.items" :key="idx">
              <a @click.prevent="secondMenu(child, index, idx)" v-if="!child.items"
                class="text-sm px-8 py-3 tracking-wider cursor-pointer" style="background-color: #f3f3f3;"
                >{{ child.title }}
              </a>

              <a @click.prevent="toggleThirdMenu(index, idx)" v-if="child.items"
                class="text-sm px-8 py-3 arrow cursor-pointer" style="background-color: #f3f3f3;"
                >{{ child.title }}
              </a>
              <ul v-if="child.items" ref="childrenItems" class="hidden bg-white" :class="{ show: Object.keys(products).indexOf(index) === main.firstIdx && idx === main.secondIdx }">
                <li v-for="children in child.items" :key="children.title">
                  <!-- 雜誌介紹 -->
                  <router-link :to="{ name: 'magazineIntro', params: { class: children.scope } }" @click.prevent="thirdMenu(index, children)" v-if="children.type === 'INTRO'"
                    class="text-sm px-8 py-3 tracking-wider cursor-pointer">{{ children.title }}
                  </router-link>
                  <!-- 其他 -->
                  <a class="text-sm px-8 py-3 tracking-wider cursor-pointer" @click.prevent="thirdMenu(index, children)" v-if="children.type !== 'INTRO'">
                    {{ children.title }}
                  </a>
                </li>
              </ul>
          </li>
        </ul>
      </li>

      <!-- 點讀館/數位學習/主題專欄 -->
      <!-- <li class="cursor-pointer text-sm text-white"
        v-for="(item, index) in pageList" :key="index">
        <router-link :to="{ name: item.name }" @click.native="closeMenu()"
          class="py-3 text-sm px-6 mobile-menu-title leading-snug block tracking-wider">{{ item.title }}
        </router-link>
      </li> -->

      <!-- 下載專區 -->
      <li class="cursor-pointer text-sm text-white">
        <router-link :to="{ name: 'download'}"
          class="py-3 text-sm px-6 mobile-menu-title leading-snug block tracking-wider">下載專區
        </router-link>
      </li>

      <!-- 每日一句 -->
      <li class="cursor-pointer text-sm text-white">
        <router-link :to="{ name: 'dailySentence'}"
          class="py-3 text-sm px-6 mobile-menu-title leading-snug block tracking-wider">每日一句
        </router-link>
      </li>

      <!-- 常見QA -->
      <li class="cursor-pointer text-sm text-white">
        <router-link :to="{ name: 'service', params: { id: 'member' } }" @click.native="closeMenu()"
          class="py-3 text-sm px-6 mobile-menu-title leading-snug block tracking-wider">常見Q&amp;A
        </router-link>
      </li>

      <!-- 會員中心 -->
      <!-- <li class="relative cursor-pointer text-sm" v-if="authorized"
        style="border: 0.5px solid rgba(255, 253, 253, 0.3);">

        <div class="text-sm px-6 py-3 mobile-menu-title leading-snug block arrow relative text-white tracking-wider"
          ref="title" @click="toggleMember()">
          會員中心</div>

        <ul class="product-menu__cat hidden bg-white" ref="memberList">
          <li class="border-b" v-for="(item, index) in member" :key="index">
            <a @click="secondMemberMenu(item)"
              class="text-sm px-8 py-3 tracking-wider" style="background-color: #f3f3f3;"
              >{{ item.title }}
            </a>
          </li>
        </ul>
      </li> -->

      <!-- 登出/登入 -->
      <li class="cursor-pointer text-base text-white">
        <!-- <router-link :to="{ name: 'login'}"  v-if="!authorized"
          class="text-sm px-6 mobile-menu-title leading-snug block tracking-wider">會員登入
        </router-link> -->
        <router-link :to="{ name: 'index'}" @click.native="signout"  v-if="authorized"
          class="text-sm px-6 mobile-menu-title leading-snug block tracking-wider py-3">登出
        </router-link>
      </li>

    </ul>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'MenuMobile',
  props: {
    isMenu: {
      type: Boolean
    }
  },
  data () {
    return {
      events: null,
      member: [
        { title: '帳號管理', link: 'manage', paramId: '' },
        { title: '訂單查詢', link: 'order', paramId: '' },
        { title: '收藏清單', link: 'favorite', paramId: '' }
      ],
      products: null,
      // pageList: [
      // { name: 'readpen', title: '點讀館' }
      // { name: 'learning', title: '數位學習' }
      // { name: 'topicList', title: '主題專欄' }
      // ],

      main: {
        firstIdx: null,
        secondIdx: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'user'
    ]),
    dailyContent () {
      if (this.dailyData) {
        let length = this.dailyData.length
        let num = Math.floor(Math.random() * length)
        return this.dailyData[num]
      } else {
        return null
      }
    }
  },
  watch: {
    isMenu (newVal, oldVal) {
      let self = this
      if (newVal === true && oldVal === false) {
        self.$refs.menu.classList.add('showMenu')
        self.$refs.menu.classList.remove('hideMenu')
        self.$refs.menu.classList.remove('hidden')
      } else if (newVal === false && oldVal === true) {
        self.$refs.menu.classList.add('hideMenu')
        self.$refs.menu.classList.remove('showMenu')
        self.removeAllClass()
        setTimeout(() => {
          self.$refs.menu.classList.add('hidden')
        }, 350)
      }
    }
  },
  mounted () {
    this.getMenu()
    this.getEvents()
  },
  beforeDestroy () {
  },
  methods: {
    returnIndexPath (type) {
      if (type === 'book' || type === 'package') {
        return `/products/${type}?type=${type.toUpperCase()}`
      } else if (type === 'magazine') {
        return `/products/newest-magazine`
      } else if (type === 'livepen') {
        return `/products/livepen?type=livepen`
      } else if (type === 'digital') {
        return `/products/digital?type=MAGAZINE,DIGITAL`
      }
    },
    initMenu () {
      let self = this
      for (let item of self.$refs.items) {
        item.classList.remove('show')
      }
    },
    toggleMember () {
      let self = this
      self.$refs.memberList.classList.toggle('show')

      // 關閉其他
      if (self.$refs.saleList.classList.contains('show')) {
        self.$refs.saleList.classList.remove('show')
      }

      for (let i = 0; i < self.$refs.childItems.length; i++) {
        if (self.$refs.childItems[i].classList.contains('show')) {
          self.$refs.childItems[i].classList.remove('show')
        }
      }
    },
    toggleEvent () {
      let self = this
      self.$refs.saleList.classList.toggle('show')

      // 關閉其他
      if (self.$refs.memberList && self.$refs.memberList.classList.contains('show')) {
        self.$refs.memberList.classList.remove('show')
      }

      for (let i = 0; i < self.$refs.childItems.length; i++) {
        if (self.$refs.childItems[i].classList.contains('show')) {
          self.$refs.childItems[i].classList.remove('show')
        }
      }
    },
    toggleMenu (index) {
      let self = this
      let idx = Object.keys(self.products).indexOf(index)

      self.$refs.childItems[idx].classList.toggle('show')

      for (let i = 0; i < self.$refs.childItems.length; i++) {
        if (i !== idx) {
          self.$refs.childItems[i].classList.remove('show')
        }
      }

      // 關閉其他
      if (self.$refs.memberList && self.$refs.memberList.classList.contains('show')) {
        self.$refs.memberList.classList.remove('show')
      }

      if (self.$refs.saleList.classList.contains('show')) {
        self.$refs.saleList.classList.remove('show')
      }
    },
    secondMemberMenu (item) {
      let self = this
      self.$router.push({
        name: item.link
      })
      self.$emit('closeMobileMenu', false)
    },
    secondSaleMenu (item) {
      let self = this
      if (self.$route.name === 'productsList') {
        self.$router.push({ name: 'sale', params: { category: self.$route.params.category }, query: { tag: item.id } })
      } else {
        self.$router.push({ name: 'sale', params: { category: 'recent' }, query: { tag: item.id } })
      }
      self.$emit('closeMobileMenu', false)
    },
    toggleThirdMenu (index, idx) {
      let self = this

      if (idx === self.main.secondIdx) {
        self.main.firstIdx = null
        self.main.secondIdx = null
      } else {
        self.main.firstIdx = Object.keys(self.products).indexOf(index)
        self.main.secondIdx = idx
      }
    },
    async getMenu () {
      let self = this
      let { data } = await axios.get('/menu/mobile')
      self.products = data
    },
    secondMenu (child, index) {
      let self = this
      if (index === 'book') {
        let obj = { name: 'productsList', params: { category: 'book' }, query: {} }
        child.type ? obj.query.type = 'BOOK,' + child.type : obj.query.type = 'BOOK'
        child.category_id ? obj.query.category = child.category_id : null

        self.$router.push(obj)
      }
      if (index === 'newbook') {
        self.$router.push({ name: 'productsList', params: { category: 'recent' }, query: { scope: child.scope } })
      }
      if (index === 'magazine') {
        self.$router.push({ name: 'productsList', params: { category: index }, query: { type: 'MAGAZINE,PLAN', category: child.category_id, scope: child.scope } })
      }
      if (index === 'package') {
        let queryObj = {}

        if (child.type) {
          queryObj.type = child.type
        }
        if (child.category_id) {
          queryObj.category = child.category_id
        }
        if (child.scope) {
          queryObj.scope = child.scope
        }
        self.$router.push({ name: 'productsList', params: { category: index }, query: queryObj })
      }
      self.$emit('closeMobileMenu', false)
    },
    thirdMenu (index, children) {
      let self = this

      let queryObj = {}

      if (children.type) {
        queryObj.type = children.type
      }
      if (children.category_id) {
        queryObj.category = children.category_id
      }
      if (children.scope) {
        queryObj.scope = children.scope
      }
      self.$router.push({ name: 'productsList', params: { category: index }, query: queryObj })

      self.$emit('closeMobileMenu', false)
    },
    async signout () {
      let self = this
      await self.$emit('closeMobileMenu', false)

      await self.$store.dispatch('logout')
      self.$router.push({ name: 'index' })
      // self.$store.dispatch('updateAlert', { isAlert: true, isHead: false, alertMsg: '您已登出', type: 'check' })
      // if (self.userRole === 'FBuser') {
      //   FB.getLoginStatus((response) => { // eslint-disable-line
      //     if (response.status === 'connected') {
      //       FB.logout((response) => { // eslint-disable-line
      //         self.$store.dispatch('logoutFB')
      //       })
      //     }
      //   })
      // } else {
      //   await self.$store.dispatch('logout')
      //   self.$router.push({ name: 'index' })
      // }
    },
    getEvents () {
      let self = this
      // let listPath = '/promote_events?type=specific'
      let listPath = '/promote_events'

      axios.get(listPath)
        .then((response) => {
          self.events = response.data.data
        })
    },
    closeMenu () {
      let self = this
      self.$emit('closeMobileMenu', false)
    },
    removeAllClass () {
      let self = this
      if (self.$refs.saleList.classList.contains('show')) {
        self.$refs.saleList.classList.remove('show')
      }
      if (self.$refs.memberList && self.$refs.memberList.classList.contains('show')) {
        self.$refs.memberList.classList.remove('show')
      }
      for (let i = 0; i < self.$refs.childItems.length; i++) {
        if (self.$refs.childItems[i].classList.contains('show')) {
          self.$refs.childItems[i].classList.remove('show')
        }
      }
      self.main.firstIdx = null
      self.main.secondIdx = null
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-menu-top {
  li {
    border-bottom: .8px solid rgba(255, 253, 253, 0.3);
  }
  top: 54px;
  // top: 70px !important;
  display: none;
  z-index: 100;
  width: 100%;
  background:rgba(51, 51, 51, 0.95);
  position: sticky;
  -ms-overflow-style: none;
  .arrow:after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 6px 0;
    border-color: #c3c3c3 transparent transparent transparent;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.mobile-menu-top::-webkit-scrollbar {
  display: none;
}
.showMenu {
  animation-name: showMenu;
  animation-duration: 0.35s;
  animation-fill-mode: forwards;
}
.hideMenu {
  animation-name: hideMenu;
  animation-duration: 0.35s;
  animation-fill-mode: forwards;
}
  @keyframes showMenu {
    from {
      height: 0em;
    }
    to {
      height: calc(100vh - 54px);
    }
  }
  @keyframes hideMenu {
    from {
      height: calc(100vh - 54px);
    }
    to {
      height: 0;
    }
  }
  @-webkit-keyframes showMenu {
    from {
      height: 0em;
    }
    to {
      height: calc(100vh - 54px);
    }
  }
  @-webkit-keyframes hideMenu {
    from {
      height: calc(100vh - 54px);
    }
    to {
      height: 0;
    }
  }
  .product-menu__cat {
    a {
      position: relative;
      padding: 0 20px;
      color: #313131;
      display: block;
      border-top: 1px solid #e2e2e2;
      transition: all .3s ease-out;
    }
  }
  .showMenuChild {
    animation-name: mobile-menu-child 0.15s linear;
    animation-duration: 0.35s;
    animation-fill-mode: forwards;
  }
  .hideMenuChild {
    animation: mobile-menu-child-hidden 0.15s linear;
    animation-fill-mode: forwards;
  }
  .show {
    display: block !important;
  }

@media (max-width:1023px) {
  .mobile-menu-top {
    display: block;
  }
  .nav__all {
    display: block;
    a, div {
      padding: 0;
      width: 44px;
      height: 44px;
      &:before {
        position: absolute;
        top: 22px;
        left: 13px;
        content: '';
        width: 18px;
        height: 1px;
        background-color: #303030;
        box-shadow: 0 6px #303030, 0 -6px #303030;
      }
    }
  }
}
</style>
